import { render, staticRenderFns } from "./DeliveryTracking.vue?vue&type=template&id=296ca900"
import script from "./DeliveryTracking.vue?vue&type=script&lang=ts"
export * from "./DeliveryTracking.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports